module.exports = __webpack_public_path__ + "img/clear.6486ea14.png";